var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3.97168H20C20.2652 3.97168 20.5196 4.07704 20.7071 4.26457C20.8946 4.45211 21 4.70646 21 4.97168V20.9717C21 21.2369 20.8946 21.4913 20.7071 21.6788C20.5196 21.8663 20.2652 21.9717 20 21.9717H4C3.73478 21.9717 3.48043 21.8663 3.29289 21.6788C3.10536 21.4913 3 21.2369 3 20.9717V4.97168C3 4.70646 3.10536 4.45211 3.29289 4.26457C3.48043 4.07704 3.73478 3.97168 4 3.97168V3.97168ZM5 5.97168V19.9717H19V5.97168H5ZM7.5 9.97168C7.10218 9.97168 6.72064 9.81364 6.43934 9.53234C6.15804 9.25104 6 8.8695 6 8.47168C6 8.07385 6.15804 7.69232 6.43934 7.41102C6.72064 7.12971 7.10218 6.97168 7.5 6.97168C7.89782 6.97168 8.27936 7.12971 8.56066 7.41102C8.84196 7.69232 9 8.07385 9 8.47168C9 8.8695 8.84196 9.25104 8.56066 9.53234C8.27936 9.81364 7.89782 9.97168 7.5 9.97168V9.97168ZM6.5 10.9717H8.5V18.4717H6.5V10.9717ZM12 11.4017C12.584 10.8367 13.266 10.4717 14 10.4717C16.071 10.4717 17.5 12.1507 17.5 14.2217V18.4717H15.5V14.2217C15.5 13.7576 15.3156 13.3124 14.9874 12.9842C14.6592 12.6561 14.2141 12.4717 13.75 12.4717C13.2859 12.4717 12.8408 12.6561 12.5126 12.9842C12.1844 13.3124 12 13.7576 12 14.2217V18.4717H10V10.9717H12V11.4017Z",
    fill: "#BDBDBD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedIn);
export default __webpack_public_path__ + "static/media/Icon_LinkedIn.6b1a62e595edaa43217556f597e8b5c6.svg";
export { ForwardRef as ReactComponent };